<!--<app-display-detail-->
<!--  [data]="users[0]"-->
<!--  [config]="userConfig">-->
<!--</app-display-detail>-->

<!-- OR -->
@if (customerDto) {
  <app-display-detail
    [data]="customerDto"
    [config]="customerCardConfig">
  </app-display-detail>

<!--  <app-display-detail-list-->
<!--    [dataArray]="customerDto"-->
<!--    [config]="customerCardConfig">-->
<!--  </app-display-detail-list>-->
}
